import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
const Dropdown = ({ items, onItemSelected, className, disabled, children }) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handleCloseItems = () => {
      setIsOpen(false);
    };

    if (isOpen) {
      document.addEventListener("click", handleCloseItems, false);
    }

    return () => {
      document.removeEventListener("click", handleCloseItems, false);
    };
  }, [isOpen]);

  function setOpen(open) {
    if (disabled) return;
    setIsOpen(open);
  }

  function handleItemClick(item) {
    if (disabled) return;
    setIsOpen(false);
    if (onItemSelected) onItemSelected(item);

    if (`onClick` in item) item.onClick();
  }

  return (
    <div className="dropdown">
      <div onClick={() => setOpen(!isOpen)}>
        <button className={`card border-0 p-0 m-0 ${className}`}>
          {children}
        </button>
      </div>
      <div className={`dropdown-menu shadow-sm ${isOpen ? "show" : "d-none"}`}>
        {items.map((item, index) => (
          <p
            key={index}
            className="dropdown-menu-item my-0 ps-4 py-2 position-relative"
            onClick={() => handleItemClick(item)}
          >
            {`link` in item ? (
              <Link to={item.link} className="stretched-link">
                {item.name}
              </Link>
            ) : (
              item.name
            )}
          </p>
        ))}
      </div>
    </div>
  );
};

export default Dropdown;
